module.exports = __webpack_public_path__ + "img/image-8.a85bf2f7.jpg";